"use strict";

import onXHRClickButton from "../tv-player-report/onxhr-click-button";
import { getMonthNames } from "../common/month-names";
import {facsimile} from "../common/facsimile";

export default apiUrl => sb => {
    let chart,
        smallChart,
        noData,
        submit,
        form,
        footnotePeriod,
        selectedMonth,
        selectedYear,
        periodSelector = null,
        selectedPeriod = null;

    const monthNames = getMonthNames();

    const renderChart = data => {
        sb.empty(noData);

        if (data.length < 1) {
            sb.empty(chart).empty(smallChart).append(noData, "<p>No data for this combination of periods and players</p>");

            hidePleaseWait();
            return;
        }

        const options = {
            chart: {
                type: 'waterfall',
                backgroundColor: 'transparent',
                height: 425,
                marginTop: 50,
            },
            title: {
                text: `${monthNames[selectedMonth]} ${selectedYear}`,
                style: {
                    color: '#000000',
                    fontWeight: 'bold'
                },
                marginBottom: 40
            },
            tooltip: {
                pointFormatter() {
                    const value = Highcharts.numberFormat(this.y, 2, ".", ",");
                    return `
                        <b>Series:</b> ${this.series.name}</br>
                        <b>Value:</b> ${value} min.<br>
                    `;
                }
            },
            legend: {
                itemStyle: {
                    color: '#000000',
                    fontWeight: 'bold'
                },
                align: 'right',
                verticalAlign: 'top',
                layout: 'vertical',
                x: 0,
                y: 100
            },
            xAxis: [
                {
                    categories: data.categories,
                    labels: {
                        style: {
                            color: '#000000',
                            fontSize: '20px;'
                        }
                    }
                },
                {
                    offset: 0,
                    opposite: true,
                    top: '100%',
                    zIndex: 10,
                    linkedTo: 0,
                    tickLength: 0,
                    labels: {
                        enabled: true,
                        top: 20,
                        allowOverlap: true,
                        formatter() {
                            if (data.reach[this.pos]) {
                                const prefix = this.pos === 0 ? 'Monthly 4-screen reach<br>' : '';
                                const className = this.pos === 0 || this.pos === 3 ? 'special-chart-value-white' : 'special-chart-value';
                                const point = data.reach[this.pos].data;
                                const millions = Highcharts.numberFormat(point.reach_millions, 1, ".", ",");
                                const percentage = Highcharts.numberFormat(point.reach_percentage, 1, ".", ",");
                                return `<span class="reach-values ${className}">${prefix}${millions}m<br>${percentage}%</span class="reach-values">`;
                            }
                        },
                        style: {
                            color: 'transparent',
                            fontSize: '14px;',
                            fontWeight: 'bold'
                        }
                    }
                }
            ],
            yAxis: {
                maxPadding: 0.2,
                gridLineColor: 'transparent',
                labels: {
                    enabled: false
                },
                title: {
                    text: '',
                    style: {
                        color: '#000000',
                        fontSize: '25px'
                    },
                    align: 'low'
                },
                stackLabels: {
                    enabled: true,
                    align: 'center',
                    verticalAlign: 'top',
                    format: '{total:,.0f} minutes per day',
                    style: {
                        color: '#000000',
                        textOutline: false,
                        fontSize: '14px;'
                    },
                },
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    pointPadding: 0,
                    groupPadding: 0,
                    lineWidth: 0
                }
            },
            credits: {
                enabled: false
            },
            series: parseDataIntoSeries(data),
            color: '#FF8AD8'
        };

        const smallOptions = facsimile(options);
        smallOptions.chart.inverted = true;

        // Different legend
        smallOptions.legend.align = "center";
        smallOptions.legend.layout = "horizontal";
        smallOptions.legend.verticalAlign = "bottom";
        delete smallOptions.legend.x;
        delete smallOptions.legend.y;

        const screenMode = jQuery(window).width();

        // Axis changes
        smallOptions.yAxis.opposite = true;
        smallOptions.yAxis.title.style.fontSize = "12px";
        smallOptions.yAxis.title.style.fontWeight = "bold";
        smallOptions.xAxis[0].labels.style.fontSize = "10px";
        smallOptions.yAxis.width = "70%";
        smallOptions.yAxis.stackLabels.align = "right";
        smallOptions.yAxis.stackLabels.style.fontSize = "10px";
        smallOptions.yAxis.stackLabels.style.textAlign = "center";
        smallOptions.yAxis.stackLabels.x = 20;
        smallOptions.yAxis.stackLabels.y = 35;
        if (screenMode > 768) {
            smallOptions.yAxis.stackLabels.useHTML = true;
        }

        smallOptions.yAxis.stackLabels.format = "{total:,.0f} minutes<br>per day";
        smallOptions.xAxis[1].opposite = false;
        smallOptions.xAxis[1].labels.x = screenMode < 768 ? 115 : 160;

        if (screenMode > 360 && screenMode < 500) {
            smallOptions.xAxis[1].labels.x = 90;
            smallOptions.xAxis[1].labels.fontSize = '12px';
        }
        smallOptions.xAxis[1].labels.align = "center";
        smallOptions.xAxis[1].labels.formatter = options.xAxis[1].labels.formatter;
        delete smallOptions.xAxis[1].top;

        sb.chart(chart, options);
        sb.chart(smallChart, smallOptions);

        hidePleaseWait();
    };

    const parseDataIntoSeries = (data) => {
        return data.series.map(point => {
            point.data = point.data.map((value, idx) => {
                return {
                    y: parseFloat(value),
                    isSum: idx === point.data.length - 1
                };
            });

            return point;
        });
    };

    const onFormSubmit = e => {
        e.preventDefault();

        const data = getQueryData(selectedPeriod);

        showPleaseWait();

        sb.postApi(apiUrl, data).then(renderChart);
    };

    const showPleaseWait = () => {
        const wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "block");
    };

    const hidePleaseWait = () => {
        const wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "none");
    };

    const getQueryData = (period) => {
        return {
            period: period
        };
    };

    return {
        init() {
            chart = sb.find(".waterfall-chart");
            smallChart = sb.find(".waterfall-chart-sm");
            noData = sb.find(".no-data");
            form = sb.find("form");
            submit = form.query("#button_submit");
            periodSelector = form.query('.period-select');
            footnotePeriod = sb.find('.footnote-period-selected');

            sb.addEvent(form, "submit", onFormSubmit);
            sb.listen({
                periodsSelectionChanged: period => {
                    selectedPeriod = period;

                    // Period format => YYYYMM
                    const year = parseInt(period.substr(0, 4));
                    const month = parseInt(period.substr(4, 2)) - 1;
                    const selectedDate = new Date(year, month + 1, 0);
                    const lastDay = selectedDate.getDate();
                    const suffix = lastDay === 31 ? 'st' : 'th';

                    selectedMonth = month;
                    selectedYear = year;

                    footnotePeriod[0].innerHTML = `${monthNames[month]} 1st-${lastDay}${suffix} ${year}`;
                }
            });

            if (periodSelector.length === 0) {
                sb.postApi('viewing-report/tiv-monthly-summary/filters').then((response) => {
                    const latestPeriod = response.periods.shift();

                    if (latestPeriod) {
                        sb.notify({type: "periodsSelectionChanged", data: latestPeriod.period_id});
                        submit[0].click();
                    } else {
                        console.log({Error: 'Empty data returned from api.'});
                    }
                })
            } else {
                onXHRClickButton(submit[0]);
            }
        },
        destroy() {
            chart = null;
            smallChart = null;
            noData = null;
            sb.ignore([
                "periodsSelectionChanged",
            ]);
            sb.removeEvent(form, "submit", onFormSubmit);
            form = null;
            submit = null;
            selectedPeriod = null;
            periodSelector = null;
            footnotePeriod = null;
        }
    }
};
